export const maskedMobileNo = (number) => {
  const maskedNumber = number.slice(-4).padStart(number.length, 'x');
  return `${maskedNumber.slice(0, 3)}-${maskedNumber.slice(3, 6)}-${maskedNumber.slice(-4)}`;
};
export const maskedEmail = (email) => {
  const emailAddress = email.split('@');
  return `${emailAddress[0].slice(0, 2).padEnd(emailAddress[0].length, '*')}@${emailAddress[1]}`;
};
